import {
  CheckResetTokenStatus,
  ICheckResetTokenResponseBody
} from "../../apis/VoiceGainAuthSvcApi/VoiceGainAuthSvcApi.types";
import CreatePasswordContentView from "./CreatePasswordContent.view";
import { ICreatePasswordFormProps } from "./CreatePasswordForm/CreatePasswordForm.types";
import { message } from "antd";
import React from "react";
import VoiceGainAuthSvcApi from "../../apis/VoiceGainAuthSvcApi";

interface IState {
  createPasswordFormIsSubmitted: boolean;
  resetToken?: string;
  resetTokenIsValid: boolean;
  uid?: string;
}

class CreatePasswordContentContainer extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    const urlSearchParams = this.getUrlSearchParams();
    const resetToken = urlSearchParams.get("rtok");
    const uid = urlSearchParams.get("uid");
    this.state = {
      createPasswordFormIsSubmitted: false,
      resetToken: resetToken === null ? undefined : resetToken,
      resetTokenIsValid: false,
      uid: uid === null ? undefined : uid
    };
  }

  public render = () => (
    <CreatePasswordContentView
      createPasswordFormProps={this.generateCreatePasswordFormProps()}
      doRedirect={this.state.createPasswordFormIsSubmitted}
      resetTokenIsValid={this.state.resetTokenIsValid}
    />
  );

  public componentDidMount = () => this.verifyResetToken();

  private generateCreatePasswordFormProps = ():
    | ICreatePasswordFormProps
    | undefined =>
    this.state.resetToken && this.state.uid
      ? {
          resetToken: this.state.resetToken,
          setFormIsSubmittedToTrue: () =>
            this.setState({
              createPasswordFormIsSubmitted: true
            }),
          uid: this.state.uid
        }
      : undefined;

  private getUrlSearchParams = () => {
    const queryString = window.location.search.substring(1);
    const urlSearchParams = new URLSearchParams(queryString);
    return urlSearchParams;
  };

  private verifyResetToken = () => {
    const { resetToken } = this.state;
    if (resetToken) {
      VoiceGainAuthSvcApi.checkResetToken(resetToken)
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Network error checking reset token");
          }
        })
        .then(({ response }: ICheckResetTokenResponseBody) => {
          if (response === CheckResetTokenStatus.Valid) {
            this.setState({ resetTokenIsValid: true });
          } else {
            throw new Error("Invalid password reset token");
          }
        })
        .catch(error => message.error(error.message));
    }
  };
}

export default CreatePasswordContentContainer;
